import api from "./api";

class PostApi {
  static getLoadPostsUrl({ limit, userId: user_id, pagingToken: paging_token, feed_index, category }) {
    let params = {};
    if (paging_token) {
      params = { ...params, paging_token };
    }
    if (limit) {
      params = { ...params, limit };
    }
    if (user_id) {
      params = { ...params, user_id };
    }
    if (category) {
      params = { ...params, category };
    }
    if (feed_index) {
      params = { ...params, feed_index };
    }
    return { url: `/v2/posts`, config: { params } };
  }

  static getLoadPostBySlugUrl(slug) {
    return { url: `/api/v1/posts/slug/${slug}` };
  }

  static getLoadPostByIdUrl(id) {
    return { url: `/api/v1/posts/${id}` };
  }

  static getLoadTopPostsUrl(count) {
    return { url: `/api/v1/posts/top/${count}` };
  }

  static editPost(postId, post) {
    return api.put(`/api/v1/posts/${postId}`, post);
  }

  static editPostAsAdmin(postId, post) {
    return api.put(`/api/v1/admin/posts/${postId}`, post);
  }

  static getPublishPostUrl(post) {
    return { url: `/api/v1/posts`, config: post };
  }

  static getDeletePostUrl(postId) {
    return { url: `/api/v1/posts/${postId}` };
  }

  static getDeletePostAsAdminUrl(postId) {
    return { url: `/api/v1/admin/posts/${postId}` };
  }

  static getHidePostAsAdminUrl(postId) {
    return { url: `/api/v1/admin/posts/${postId}`, config: { isActive: false } };
  }

  static getUnhidePostAsAdminUrl(postId) {
    return { url: `/api/v1/admin/posts/${postId}`, config: { isActive: true } };
  }

  static getFloatPostAsAdminUrl(postId) {
    return { url: "/api/v1/admin/posts/float", config: { postId } };
  }

  static getTogglePostLikeUrl(postId) {
    return { url: `/api/v1/posts/${postId}/likes` };
  }

  static getGUIDUrl() {
    return {
      url: `https://casemastersworkers.azurewebsites.net/api/GenerateGuid`,
    };
  }

  static getNotifyUrl(data) {
    return { url: `/api/v1/notify`, config: data };
  }
  //////////////////////////// COMMENTS \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  static getLoadPostCommentsUrl(postId, { limit, pagingToken }) {
    const params = {};
    if (limit) {
      params.limit = limit;
    }
    if (pagingToken) {
      params.paging_token = pagingToken;
    }
    return { url: `/api/v1/posts/${postId}/comments`, config: { params } };
  }

  static getCreateCommentUrl(postId, content) {
    return { url: `/api/v1/posts/${postId}/comments`, config: { content } };
  }
  static getEditCommentsUrl({ postId, commentId, content }) {
    return {
      url: `/api/v1/posts/${postId}/comments/${commentId}`,
      config: { content },
    };
  }

  static getDeleteCommentUrl({ postId, commentId }) {
    return { url: `/api/v1/posts/${postId}/comments/${commentId}` };
  }

  static getLoadSimilarPostsUrl(postId, { pagingToken }) {
    const params = { paging_token: pagingToken };
    return { url: `/v2/posts/${postId}/similar`, config: { params } };
  }

  static getRatePostRequest(postId, rating) {
    const params = { rating };
    return { url: `/api/v1/posts/${postId}/ratings`, config: params };
  }
}

export default PostApi;



// WEBPACK FOOTER //
// ./src/api/PostApi.js